<template>
  <CRow class="main py-5 mt-3">
    <CCol class="py-2">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
      <CRow class="">
        <CCol class="h-100">
          <div class="pb-2 h6">
            <h4 class="mt-4 font-weight-normal">
              {{ $t('settings.profile.basicInfo.header.basicInfo') }}
            </h4>
          </div>
          <div class="border-line"></div>
          <div class="mt-4 pb-2">
            <div class="h6 text-gray-base mb-2">{{ $t('settings.profile.basicInfo.header.photo') }}</div>
            <div v-if="!exibirImagem" class="photo-div bg-gray-200 mt-2" @click="clickPhoto()">
              <i class="fas fa-user-alt text-gray-500"></i>
            </div>
            <div v-if="exibirImagem">
              <img :key="imageUrl" :src="imageUrl" class="photo-div" @error="errorImage()" @click="clickPhoto()" />
            </div>
          </div>
        </CCol>
      </CRow>
      <input type="file" ref="fileUploader" @change="loadImage($event)" accept="image/x-png,image/png,image/jpg,image/jpeg" style="display: none" />
      <CForm autocomplete="OFF" @submit.prevent="click_save" class="mt-4">
        <CRow class="mb-4">
          <CCol>
            <CInput
              :label="$t('settings.profile.basicInfo.input.label.userName')"
              type="text"
              maxlength="255"
              id="name"
              :value.sync="user.name"
              addLabelClasses="mb-0 required"
              :placeholder="$t('settings.profile.basicInfo.input.label.userName')"
            />
          </CCol>
          <CCol>
            <CRow :gutters="false">
              <CCol md="7" class="pr-2">
                <label class="font-label">
                  {{ $t('settings.profile.basicInfo.label.timeZone') }}
                </label>
                <v-select
                  class="mb-0 no-close options-w-auto"
                  :placeholder="$t('settings.profile.basicInfo.label.timeZone')"
                  id="timezones"
                  item-text="label"
                  item-value="value"
                  v-model="aux.timeZone"
                  :options="timeZones"
                  @input="inputTimeZone()"
                  v-if="rerenderDOM"
                >
                </v-select>
              </CCol>
              <CCol md="5">
                <label class="font-label">
                  {{ $t('settings.profile.basicInfo.label.dateTimeFormat') }}
                </label>
                <v-select class="mb-0 no-close" v-model="aux.datetimeFormat" :options="dateFormats" @input="inputDateFormat()" v-if="rerenderDOM">
                </v-select>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
        <CRow class="mb-4">
          <CCol>
            <label class="font-label mb-none">
              {{ $t('settings.profile.basicInfo.label.Language') }}
            </label>
            <v-select
              class="mb-0 no-close"
              :placeholder="$t('settings.profile.basicInfo.placeholder.Language')"
              v-model="aux.language"
              :options="languages"
              @input="inputLanguage()"
              v-if="rerenderDOM"
            >
            </v-select>
          </CCol>
          <CCol>
            <label class="font-label">
              {{ $t('settings.profile.basicInfo.label.country') }}
            </label>
            <v-select
              class="mb-0 no-close"
              :placeholder="$t('settings.profile.basicInfo.placlaceholder.select-country')"
              v-model="aux.country"
              :options="countries"
              @input="inputCountry()"
              v-if="rerenderDOM"
            >
            </v-select>
          </CCol>
        </CRow>
        <CButton type="submit" class="btn btn-primary text-uppercase mt-md-4 px-5" :disabled="disableButton">
          {{ $t('settings.profile.basicInfo.button.save') }}
        </CButton>
      </CForm>
      <CModal title="Change Photo" :show.sync="showModal" centered :closeOnBackdrop="false">
        <template slot="body-wrapper" style="min-width: 800px; max-width: 800px">
          <CRow class="pl-4 pr-4 pt-4 pb-4">
            <CCol md="8">
              <div class="h5 text-gray-base mb-3">
                {{ $t('settings.profile.basicInfo.header.setPhoto') }}
              </div>
              <Cropper
                ref="crooper"
                :src="image"
                :auto-zoom="true"
                :stencil-size="stencilSize"
                image-restriction="stencil"
                :stencil-props="{
                  previewClass: 'preview',
                }"
                stencil-component="circle-stencil"
                @change="onChange"
              />
            </CCol>
            <CCol md="4">
              <div class="h5 text-gray-base mb-3">
                {{ $t('settings.profile.basicInfo.header.previewSaquare') }}
              </div>
              <div class="mb-5">
                <Preview
                  style="border: 1px solid black"
                  class="q-ml-md"
                  :width="190"
                  :height="190"
                  :image="result.image"
                  :coordinates="result.coordinates"
                />
              </div>
              <div class="h5 text-gray-base mb-3">
                {{ $t('settings.profile.basicInfo.header.previewRounded') }}
              </div>
              <div>
                <Preview
                  style="border-radius: 60px !important; border: 1px solid black"
                  class="q-ml-md"
                  :width="120"
                  :height="120"
                  :image="result.image"
                  :coordinates="result.coordinates"
                />
              </div>
            </CCol>
          </CRow>
        </template>
        <template slot="footer-wrapper">
          <div style="border-bottom: 1px solid #edeff1"></div>
          <div style="height: 50px" class="text-right pr-3 pt-2">
            <CButton color="primary" :disabled="disableButtonSaveImage" @click="uploadImage()">
              {{ $t('settings.profile.basicInfo.button.saveImage') }}
            </CButton>
          </div>
        </template>
      </CModal>
    </CCol>
  </CRow>
</template>

<script>
import { Cropper, Preview } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import vSelect from 'vue-select'
import { required, maxLength } from 'vuelidate/lib/validators'
import services from '@/services.js'
import { nameCountries } from '@/utils/countriesUtils.js'
import MenssageAlert from '@/components/MenssageAlert'

// import services from '../userProfile-services'

export default {
  components: { Cropper, Preview, vSelect, MenssageAlert },
  data() {
    return {
      disableButton: false,
      showModal: false,
      disableButtonSaveImage: false,
      exibirImagem: true, // true,
      imageUrl: null,
      image: null,
      imageType: null,
      user: {},
      aux: {},
      result: {
        coordinates: null,
        image: null,
      },
      timeZones: [],
      dateFormats: [
        // { label: 'MM/dd/yyyy', value: 'MM/dd/yyyy' },
        // { label: 'dd/MM/yyyy', value: 'dd/MM/yyyy' },
        // { label: 'yyyy/dd/MM', value: 'yyyy/dd/MM' },
        // { label: 'yyyy/MM/dd', value: 'yyyy/MM/dd' },
      ],
      // TODO Alterar quando listagem final de línguas já estiver definida
      languages: [
        { label: 'English', value: '1' },
        { label: 'Portuguese', value: '2' },
      ],
      countries: [],
      messages: [],
      rerenderDOM: true,
    }
  },
  validations: {
    user: {
      name: {
        required,
        maxLength: maxLength(255),
      },
    },
  },
  methods: {
    stencilSize({ boundaries }) {
      if (boundaries.height < 280) {
        return {
          width: boundaries.height * 0.5,
          height: boundaries.height * 0.5,
        }
      }
      return {
        width: 280,
        height: 280,
      }
    },
    imageSizes({ visibleArea, imageSize, stencilRatio, sizeRestrictions }) {
      if (visibleArea.width < 280) {
        return {
          width: 300,
          height: 300,
        }
      }
      return {
        width: visibleArea.width,
        height: visibleArea.width,
      }
    },
    errorImage() {
      this.exibirImagem = false
    },
    clickPhoto() {
      this.$refs.fileUploader.value = null
      this.$refs.fileUploader.click()
    },
    loadImage(event) {
      var input = event.target

      if (input.files && input.files[0]) {
        this.imageType = input.files[0].type
        var reader = new FileReader()
        reader.onload = (e) => {
          this.image = e.target.result
          this.showModal = true
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    onChange({ coordinates, image }) {
      this.result = {
        coordinates,
        image,
      }
    },
    uploadImage() {
      const { canvas } = this.$refs.crooper.getResult()

      if (canvas) {
        canvas.toBlob((blob) => {
          let form = new FormData()

          form.append('name', 'userImage')
          form.append('file', blob)

          this.disableButtonSaveImage = true

          services
            .uploadImage(form, this.imageType)
            .then((res) => {
              this.imageUrl = this.imageUrl + '1'
              this.$store.commit('auth/CHANGE_IMAGE')
              this.$emit('changeImage')
            })
            .finally(() => {
              this.showModal = false
              this.exibirImagem = true
              this.disableButtonSaveImage = false
            })
        })
      }
    },
    inputTimeZone() {
      this.user.timeZone = this.aux.timeZone.value
      this.rerenderDOM = false
      this.$nextTick(() => (this.rerenderDOM = true))
    },
    inputDateFormat() {
      this.user.datetimeFormat = this.aux.datetimeFormat.value
      this.rerenderDOM = false
      this.$nextTick(() => (this.rerenderDOM = true))
    },
    inputLanguage() {
      this.user.language = this.aux.language.value
      this.rerenderDOM = false
      this.$nextTick(() => (this.rerenderDOM = true))
    },
    setLanguage(vl) {
      const lang = vl == 1 ? 'en-US' : 'pt-PT'

      this.$i18n.locale = lang

      this.$store.commit('UPDATE_LANG', lang)
      localStorage.setItem('lang', lang)

      // ! Este atraso foi colocado em virtude de não haver tempo de ler a mensagem
      setTimeout(() => {
        location.reload()
      }, 2000)
    },
    inputCountry() {
      this.user.country = this.aux.country.value
      this.rerenderDOM = false
      this.$nextTick(() => (this.rerenderDOM = true))
    },
    click_save() {
      this.messages = []
      this.disableButton = true
      services
        .updateBasicInfo(this.$store.state.auth.user.id, this.user)
        .then((res) => {
          this.messages.push({
            status: 'success',
            text: this.$t('settings.profile.basicInfo.message.successSave'),
          })
          this.setLanguage(this.aux.language.value)

          // TODO: Alterar para um lugar adequado (isolar em alguma lib)
          let user = JSON.parse(localStorage.getItem('user'))

          for (var item in res.data.data) {
            if (user[item]) {
              user[item] = res.data.data[item]
            }
          }
          localStorage.setItem('user', JSON.stringify(user))
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
        .finally(() => (this.disableButton = false))
    },

    getDateFormats(format) {
      services.getDateFormats().then((res) => {
        this.dateFormats = res.data.map((elm) => {
          return { label: elm, value: elm }
        })
        if (format) this.aux.datetimeFormat = this.dateFormats.find((elm) => elm.value === format)
      })
    },
  },
  mounted() {
    this.countries = nameCountries(this)

    this.imageUrl = `${this.$configs.VUE_APP_ROOT_API}user/api/v1.0/user/profile/${this.$store.state.auth.user.id}/image/small?v=1`
    // this.imageUrl = `https://localhost:5001/services/user/api/v1.0/user/profile/${this.$store.state.auth.user.id}/image/small?v=1`

    services.getBasicInfo(this.$store.state.auth.user.id).then((res) => {
      var obj = res.data.data
      for (var i in res.data.data) {
        this.user[i] = res.data.data[i]
      }
      // if (obj.datetimeFormat) this.aux.datetimeFormat = this.dateFormats.find((elm) => elm.value === obj.datetimeFormat)
      this.getDateFormats(obj.datetimeFormat)

      if (obj.language) this.aux.language = this.languages.find((elm) => elm.value === obj.language.toString())

      if (obj.country) this.aux.country = this.countries.find((elm) => elm.value === obj.country)

      services.timeZones().then((res) => {
        this.timeZones = res.data.data
          .map((elm) => {
            elm.label = elm.timeZoneDescription
            elm.value = elm.timeZoneId
            return {
              label: `${elm.timeZoneDescription} | ${this.$t(`general.components.selects.timeZone.${elm.timeZoneId}`)}`,
              value: elm.timeZoneId,
            }
          })
          .sort((countryA, countryB) => {
            const UTC_A = Number(countryA.label.split(' ')[1].replace('h', ' '))
            const UTC_B = Number(countryB.label.split(' ')[1].replace('h', ' '))

            return UTC_A - UTC_B
          })

        if (this.user.timeZone) {
          this.aux.timeZone = this.timeZones.find((elm) => elm.value === this.user.timeZone)
        }
      })
    })
  },
}
</script>

<style>
.options-w-auto ul {
  width: auto !important;
}

.item-menu {
  min-height: 37px !important;
  cursor: pointer !important;
  font-size: 12px;
  font-weight: 600;
  border-radius: 3px;
}

.item-menu-active {
  background-color: #e2e4e7;
}

.font-default {
  font-family: NunitoSans;
}

.border-line {
  border-bottom: 1px solid #d1d4da;
}

.profile-name {
  font-size: 13px !important;
}

.photo-div {
  width: 100px;
  height: 100px;
  cursor: pointer;
  position: relative;
}
.photo-div i {
  position: absolute;
  top: 35%;
  left: 35%;
  font-size: 30px;
}

.modal-dialog-centered {
  max-width: 800px !important;
}

.font-label {
  font-weight: 600;
  margin-bottom: 0px !important;
}
</style>
